export class steps {
  guildData = [
    {
      element: '#guide-menu',
      popover: {
        title: '菜单导航',
        description: `欢迎来到短信中心理系统！！！<br>
        1.点击菜单可切换右侧菜单内容`,
        position: 'right'
      }
    },
    {
      element: '#collapse-box',
      popover: {
        title: '退出登录',
        description:
          '点击“退出登录”，可返回到登录页面',
        position: 'left'
      },
      padding: 5
    },
    {
      element: '#guide-breadcrumb',
      popover: {
        title: '用户资料(登陆账号)',
        description:
          '点击用户名可进行“退出登陆”，“修改密码”，“绑定谷歌验证码”操作',
        position: 'bottom'
      }
    },
    {
      element: '.user-content',
      popover: {
        title: '个人中心',
        description: '点击可操作',
        position: 'left'
      }
    },
    {
      element: '#tagsView',
      popover: {
        title: '最近打开任务',
        description: '最近打开任务菜单，点击可快速切换',
        position: 'bottom'
      }
    }
  ]
}
